/**
 * UserProfile Routes
 */
// async components
import {AsyncUserProfileComponent} from '../components/AsyncComponent/AsyncComponent';
/* eslint-disable */
import * as React from 'react';
import {Route, RouteChildrenProps, Switch} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import {config} from "../config";

const UserProfile: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('users.name')}`}</title>
                <meta name="description" content="UserProfile"/>
            </Helmet>
            <Switch>
                <Route path={`${match?.url}`} component={AsyncUserProfileComponent}/>
            </Switch>
        </div>
    );
}

export default UserProfile;
